export const getCurrentIntegration = (data, userTenant, type) =>
  data.find(
    ({ integration_type, status, tenant_id }) =>
      integration_type === type && status === "active" && tenant_id === userTenant
  );
